// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems___yd_d"};